import type { StatsSnapshot } from './gameplay-snapshot';
import { useCurrencyStore } from '../store/zustand/useCurrencyStore';
import { multiplyAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { unitStats as stats } from './index';
import { CONFIG } from '../config';

export const updateClickStats = (state: StatsSnapshot) => {
  const { ironFinger, moneyCursor } = state.upgrades.click;

  const currency = useCurrencyStore.getState();
  const inspirationMultiplier = currency.inspiration.remainingActive > 0 ? currency.inspiration.multiplier : 1;
  const clickDamageMultipliers = multiplyAll([inspirationMultiplier, ironFinger.multiplier]);
  const damagePerClick = CONFIG.game.damagePerClick * clickDamageMultipliers;

  const goldMultiplier = multiplyAll([moneyCursor.multiplier]);
  const goldGeneration = CONFIG.game.goldPerDamage * damagePerClick * goldMultiplier;

  stats.click = {
    damagePerClick,
    goldGeneration,
  };
};
